import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`;

const Legend = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Color = styled.div<{ legendColor: string }>`
  min-width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props) => props.legendColor};
`;

const Text = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  font-size: 12px;
`;

export { Container, Legend, Color, Text };